import React, { Fragment, useState, useEffect, useRef } from "react";
import { closeModal } from "../../store/modal/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";
import { Formik, Form } from "formik";
import ErrorBoundary from "../../containers/ErrorBoundary";
import SubmitButton from "../Forms/SubmitButton";
import { toast } from "react-toastify";
import NotificationToast from "../../components/Helpers/NotificationToast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import TimeSince from "../Helpers/TimeSince";
import moment, { now } from "moment/moment";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ModalBulkArchive(props) {
  const dispatch = useDispatch();
  const [open] = useState(true);
  // Hard guard against double bulk-posting: a fast double-click can fire the
  // submit handler twice before Formik's isSubmitting re-render disables the
  // button. This ref blocks any re-entry while a batch is in flight.
  const isProcessingRef = useRef(false);
  const [listLoaded, setListLoaded] = useState(false);
  const [sendList, setSendList] = useState([]);
  const { properties } = useSelector((state) => state.properties);
  const [selClosed, setSelClosed] = useState("");
  const [selWifi, setSelWifi] = useState("");
  const [selYear, setSelYear] = useState(0);
  const [selBudget, setSelBudget] = useState("");
  const [selMessageFilter, setSelMessageFilter] = useState("");
  const [selGender, setSelGender] = useState("");
  const [selHasBed, setSelHasBed] = useState("");
  const [selDocuments, setSelDocuments] = useState("");
  const [closeType, setCloseType] = useState([
    { label: "Open", value: 0 },
    { label: "Closed", value: 1 },
  ]);
  const [years, setYears] = useState([]);

  const [wifiType, setWifiType] = useState([
    { label: "WiFi OFF", value: 0 },
    { label: "WiFi ON", value: 1 },
  ]);
  const [studentTypes, setStudentTypes] = useState([
    { label: "NSFAS UJ", value: 4 },
    { label: "NSFAS WITS", value: 5 },
    // { label: "CJC", value: 6 },
    { label: "NSFAS TVET", value: 1 },
    { label: "NSFAS NDT", value: 8 },
    { label: "Bursary", value: 2 },
    { label: "Private", value: 3 },
  ]);
  const [genderTypes] = useState([
    { label: "Male", value: 1 },
    { label: "Female", value: 2 },
  ]);
  const [selStudentType, setSelStudentType] = useState("");
  const [actionType, setActionType] = useState([]);
  const [selOlderThan, setSelOlderThan] = useState(0);
  const [studyYear, setStudyYear] = useState(0);
  const [action, setAction] = useState("");
  const [locations, setLocations] = useState({
    noTags: [], // folders with has_tag = 0, not under_property
    underProperty: [], // folders under a property
    hasTags: [], // folders with has_tag = 1
  });
  const { tags } = useSelector((state) => state.tags);
  const [chosenLocation, setChosenLocation] = useState([]);
  const [chosenTag, setChosenTag] = useState([]);
  const [chosenArchiveTag, setChosenArchiveTag] = useState("");
  const [selProperty, setSelProperty] = useState("");
  const [selBookingSummary, setSelBookingSummary] = useState(0);
  const [selUnitType, setSelUnitType] = useState(0);
  const [selMDABalance, setSelMDABalance] = useState(0);
  const [balanceAmountMin, setBalanceAmountMin] = useState(0);
  const [balanceAmountMax, setBalanceAmountMax] = useState(0);

  const [locationChecked, setLocationChecked] = useState(false);
  const [messageFilterType, setMessageFilterType] = useState(0);

  const { current_staff } = useSelector((state) => state.auth);
  const [lastMsgFrom, setSelLastMsgFrom] = useState(0);
  const [lookups, setLookups] = useState([]);
  const [selBotFlow, setSelBotFlow] = useState(0);
  const botFlowTypes = [
    { label: "All Robots", value: 0 },
    { label: "Red", value: 1 },
    { label: "Green", value: 2 },
    { label: "Bot Flow", value: 3 },
  ];
  const [mdaBalanceTypes] = useState([
    { label: "Any Balance", value: 0 },
    { label: "Balance In Arrears", value: 2 },
    { label: "Balance OK", value: 1 },
  ]);
  const [renewalTypes] = useState([
    { label: "No Renewal Check", value: "" },
    { label: "Renewal", value: 1 },
    { label: "Not Renewal", value: 0 },
  ]);
  const [renewalChoiceOptions] = useState([
    { label: "All Renewal Choices", value: "" },
    { label: "YES, RENEW", value: "YES, RENEW" },
    { label: "REMAIN MONTH 2 MONTH", value: "REMAIN MONTH 2 MONTH" },
    { label: "MONTH 2 MONTH LEAVING", value: "MONTH 2 MONTH LEAVING" },
    { label: "LEAVING, END JAN", value: "LEAVING, END JAN" },
    { label: "LEAVING, END FEB", value: "LEAVING, END FEB" },
    { label: "LEAVING, END MAR", value: "LEAVING, END MAR" },
    { label: "LEAVING, END APR", value: "LEAVING, END APR" },
    { label: "LEAVING, END MAY", value: "LEAVING, END MAY" },
    { label: "LEAVING, END JUN", value: "LEAVING, END JUN" },
    { label: "LEAVING, END JUL", value: "LEAVING, END JUL" },
    { label: "LEAVING, END AUG", value: "LEAVING, END AUG" },
    { label: "LEAVING, END SEP", value: "LEAVING, END SEP" },
    { label: "LEAVING, END OCT", value: "LEAVING, END OCT" },
    { label: "LEAVING, END NOV", value: "LEAVING, END NOV" },
    { label: "LEAVING, END DEC", value: "LEAVING, END DEC" },
  ]);
  const [cancellationTypeOptions] = useState([
    { label: "All Cancellation Types", value: "" },
    { label: "Early Termination", value: "early_termination" },
    { label: "Abscond", value: "abscond" },
    { label: "Eviction", value: "eviction" },
  ]);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [selIsRenewal, setSelIsRenewal] = useState("");
  const [selRenewalChoice, setSelRenewalChoice] = useState("");
  const [selCancellationType, setSelCancellationType] = useState("");
  const [robotColour, setRobotColour] = useState("red");
  const [snoozeUntil, setSnoozeUntil] = useState("");

  useEffect(() => {
    if (locationChecked === false) {
      setLocationChecked(true);
      if (props.type === "collections") {
        setActionType([
          { label: "Turn WiFi ON", value: 4 },
          { label: "Turn WiFi OFF", value: 5 },
        ]);
      } else if (props.type !== "collections" && props.type !== "renewals") {
        setActionType([
          { label: "Archive", value: 1 },
          { label: "Close", value: 2 },
          { label: "Move", value: 3 },
          { label: "Set Active", value: 7 },
          { label: "MDA Create Tenant + Lease", value: 6 },
          { label: "Stop Bot Flow", value: 9 },
          { label: "Snooze", value: 10 },
          { label: "Un-Snooze", value: 11 },
        ]);
      } else {
        setActionType([
          { label: "Close", value: 2 },
          { label: "Move", value: 3 },
          { label: "Move from Renewal", value: 8 },
          { label: "Set Active", value: 7 },
          { label: "Stop Bot Flow", value: 9 },
          { label: "Snooze", value: 10 },
          { label: "Un-Snooze", value: 11 },
        ]);
      }
    }

    if (listLoaded === false) {
      let sendListNew = props.bookings.filter(function (sl) {
        // let sendListNew = props.allBookings.filter(function (sl) {
        if (!sl.checked) {
          sl.checked = true;
        }

        if (
          selProperty === "" ||
          parseInt(selProperty) === parseInt(sl.i) ||
          (parseInt(selProperty) === 1000 && sl.i === null)
        ) {
          if (
            selStudentType === "" ||
            parseInt(selStudentType) === parseInt(sl.v)
          ) {
            if (
              selIsRenewal === "" ||
              (selIsRenewal === "1" && sl.ba === 1) ||
              (selIsRenewal === "0" && (!sl.ba || sl.ba === 0))
            ) {
              if (
                selRenewalChoice === "" ||
                sl.bb === selRenewalChoice
              ) {
                if (
                  selCancellationType === "" ||
                  sl.cancellation_type === selCancellationType
                ) {
                  if (
                    selClosed === "" ||
                    (selClosed == 1 && sl.g === 1) ||
                    (selClosed == 0 && sl.g !== 1)
                  ) {
                    if (studyYear == 0 || studyYear == sl.am) {
                      if (
                        selWifi === "" ||
                        (selWifi == 1 && sl.ac === 1) ||
                        (selWifi == 0 && sl.ac === 0)
                      ) {
                        if (
                          selBotFlow == 0 ||
                          (parseInt(sl.al) > 0 && selBotFlow == 3) ||
                          (sl.s === "a" && selBotFlow == 2) ||
                          (sl.s === "c" && selBotFlow == 1)
                        ) {
                          // Auto-filter for Stop Bot Flow: only show bookings in bot flows
                          if (action === "9" && (!sl.al || parseInt(sl.al) === 0)) {
                            return false;
                          }
                          // Auto-filter for Un-Snooze: only show snoozed bookings (j = snooze_until)
                          if (action === "11" && !sl.j) {
                            return false;
                          }
                          if (
                            selHasBed === "" ||
                            (selHasBed === "1" && sl.ar > 0) ||
                            (selHasBed === "2" && (!sl.ar || sl.ar === 0))
                          ) {
                            if (
                              selMDABalance === 0 ||
                              (selMDABalance === 1 &&
                                (() => {
                                  console.log("Balance OK check:", {
                                    value: sl.av,
                                    type: typeof sl.av,
                                    comparison: sl.av <= 0,
                                    stringified: String(sl.av) <= 0,
                                  });
                                  return sl.av <= 0;
                                })()) ||
                              (selMDABalance === 2 &&
                                (() => {
                                  console.log("Balance In Arrears check:", {
                                    value: sl.av,
                                    type: typeof sl.av,
                                    comparison: sl.av > 0,
                                    stringified: String(sl.av) > 0,
                                    min: balanceAmountMin,
                                    max: balanceAmountMax,
                                  });
                                  return (
                                    sl.av > 0 &&
                                    (!balanceAmountMin ||
                                      sl.av >= balanceAmountMin) &&
                                    (!balanceAmountMax || sl.av <= balanceAmountMax)
                                  );
                                })())
                            ) {
                              if (
                                parseInt(selBookingSummary) === 0 ||
                                (parseInt(selBookingSummary) === 1 &&
                                  sl.ap === "yes") ||
                                (parseInt(selBookingSummary) === 2 && sl.ap === "no")
                              ) {
                                if (
                                  selGender === "" ||
                                  sl.x === parseInt(selGender)
                                ) {
                                  if (
                                    selBudget === "" ||
                                    parseInt(selBudget) === sl.aq
                                  ) {
                                    if (
                                      parseInt(selUnitType) === 0 ||
                                      (parseInt(selUnitType) === 1 && sl.u > 0) ||
                                      (parseInt(selUnitType) === 2 &&
                                        (sl.u === 0 || sl.u === null))
                                    ) {
                                      if (selYear == 0 || selYear == sl.af) {
                                        if (
                                          selDocuments === "" ||
                                          (selDocuments === "missing" &&
                                            sl.documents_status ===
                                            "missing_required") ||
                                          (selDocuments === "uploaded" &&
                                            (sl.documents_status === "all_uploaded" ||
                                             sl.documents_status === "not_yet_required"))
                                        ) {
                                          if (
                                            selOlderThan === 0 ||
                                            selOlderThan == "" ||
                                            moment(
                                              moment()
                                                .subtract(
                                                  parseFloat(selOlderThan),
                                                  "days"
                                                )
                                                .format("Y-MM-DD")
                                            ).isSameOrBefore(
                                              moment(
                                                moment(
                                                  lastMsgFrom === 1
                                                    ? sl.n
                                                    : sl.nn
                                                ).format("Y-MM-DD")
                                              )
                                            ) === false
                                          ) {
                                            // Add message filter check
                                            if (selMessageFilter !== "") {
                                              const lastMessage = getLastMessage(sl);
                                              return lastMessage
                                                .toLowerCase()
                                                .includes(
                                                  selMessageFilter.toLowerCase()
                                                );
                                            }
                                            return true;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } else {
          return false;
        }
      });

      setSendList(sendListNew);
      getFolders();
      setListLoaded(true);
    }
  }, [listLoaded]);

  const getLastMessage = (booking) => {
    const nTime = new Date(booking.n).getTime() || 0;
    const nnTime = new Date(booking.nn).getTime() || 0;

    // If nn timestamp is more recent, show oo message
    // Otherwise show o message
    if (nnTime > nTime) {
      return booking.oo
        ? booking.oo.replace(/<\/?[^>]+(>|$)/g, "")
        : booking.o
          ? booking.o.replace(/<\/?[^>]+(>|$)/g, "")
          : "No Message";
    } else {
      return booking.o
        ? booking.o.replace(/<\/?[^>]+(>|$)/g, "")
        : booking.oo
          ? booking.oo.replace(/<\/?[^>]+(>|$)/g, "")
          : "No Message";
    }
  };

  useEffect(async () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}uc_lookups`,
    })
      .then((response) => {
        setLookups(response.data);
      })
      .catch((error) => {
        // alert("lookups failed");
      });

    // Fetch years dynamically
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}get_years`,
    })
      .then((response) => {
        setYears(response.data);
      })
      .catch((error) => {
        console.error("Failed to load years", error);
      });
  }, []);

  async function getFolders() {
    await axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}folders`,
    }).then((response) => {
      let allFolders = response.data.folders;
      let noTagsFolders = [];
      let underPropertyFolders = [];
      let hasTagsFolders = [];

      // Filter out specific folders we don't want to show
      const excludedFolders = ["All", "Declined", "Cancelled", "Archived"];

      // Folders are already sorted by sort_order from the backend
      allFolders.forEach((folder) => {
        if (folder.is_property_container) return;
        if (excludedFolders.includes(folder.name)) return;

        // Create the folder object
        const folderObj = {
          id: folder.id,
          name: folder.name === "All Residents" ? "Residents" : folder.name,
          sort_order: folder.sort_order || 0,
          property_sort_order: folder.property_sort_order || 0,
        };

        if (folder.under_property) {
          underPropertyFolders.push(folderObj);
        } else if (Number(folder.has_tags) === 1) {
          hasTagsFolders.push(folderObj);
        } else {
          noTagsFolders.push(folderObj);
        }
      });

      noTagsFolders.sort((a, b) => a.sort_order - b.sort_order);
      underPropertyFolders.sort((a, b) => a.property_sort_order - b.property_sort_order);
      hasTagsFolders.sort((a, b) => a.sort_order - b.sort_order);

      setLocations({
        noTags: noTagsFolders,
        underProperty: underPropertyFolders,
        hasTags: hasTagsFolders,
      });
    });
  }

  function changeList(e, res) {
    let sendListNew = sendList.map((sl) => {
      if (!sl.checked) {
        sl.checked = false;
      }

      if (sl.a === res.a) {
        sl.checked = e.target.checked;
      }

      return sl;
    });

    setSendList(sendListNew);
  }

  function changeListAll(checked) {
    let sendListNew = sendList.map((sl) => {
      sl.checked = checked;

      return sl;
    });

    setSendList(sendListNew);
  }

  function setClosed(e) {
    setSelClosed(e.target.value);
    setListLoaded(false);
  }

  function setWifi(e) {
    setSelWifi(e.target.value);
    setListLoaded(false);
  }

  function setYear(e) {
    setSelYear(e.target.value);
    setListLoaded(false);
  }

  function setBookingSummary(e) {
    setSelBookingSummary(e);
    setListLoaded(false);
  }

  function setBudget(e) {
    setSelBudget(e.target.value);
    setListLoaded(false);
  }

  function setUnitType(e) {
    setSelUnitType(e);
    setListLoaded(false);
  }

  function setLastMsgFrom(e) {
    setSelLastMsgFrom(e.target.value);
    setListLoaded(false);
  }

  async function setProp(e) {
    setSelProperty(e.target.value);
    setListLoaded(false);
  }

  function setFunding(e) {
    setSelStudentType(e.target.value);
    setListLoaded(false);
  }

  function setMessageFilter(e) {
    setSelMessageFilter(e);
    setListLoaded(false);
  }

  function setGender(e) {
    setSelGender(e.target.value);
    setListLoaded(false);
  }

  function setMDABalance(e) {
    setSelMDABalance(parseInt(e.target.value));
    setListLoaded(false);
  }

  function setBalanceAmountValue(e) {
    setBalanceAmount(parseFloat(e.target.value));
    setListLoaded(false);
  }

  // Filter tags based on selected location
  const getTagsForLocation = (locationName) => {
    console.log("Getting tags for location:", locationName);
    const filteredTags = tags.filter(
      (tag) => tag.parent_folder === locationName
    );
    console.log("Filtered tags:", filteredTags);
    return filteredTags;
  };

  // Helper function to check if a tag is valid for a location
  const isTagValidForLocation = (tagId, locationName) => {
    if (!tagId) return false;
    const validTags = getTagsForLocation(locationName).map((tag) =>
      String(tag.id)
    );
    return validTags.includes(String(tagId));
  };

  // Helper to determine tag status (notag, orphaned, validtag)
  const getTagDisplayStatus = (currentTagId, locationName) => {
    // If no tag (null, 0, etc), show as "No Tag"
    if (!currentTagId || currentTagId === 0 || currentTagId === "0") {
      return "notag";
    }
    // Check if tag exists in the location's available tags
    const availableTags = getTagsForLocation(locationName).map((tag) =>
      Number(tag.id)
    );
    if (availableTags.includes(Number(currentTagId))) {
      return "validtag"; // Tag exists and is valid
    }
    // Tag is set but not available for this location - orphaned
    return "orphaned";
  };

  // Add this before the return statement
  const selectClass =
    "block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary";

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-50 inset-0 overflow-y-auto"
        open={open}
        onClose={() => dispatch(closeModal())}
      >
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[90%] sm:w-full sm:p-6">
              <div className="flex">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h1"
                    className="text-lg font-medium text-gray-900 capitalize"
                  >
                    Bulk Action - {props.booking_list_name}
                  </Dialog.Title>
                </div>

                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-right grow">
                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-0"
                    onClick={() => dispatch(closeModal())}
                  >
                    <span className="sr-only">Close</span>
                    <FontAwesomeIcon
                      className="h-6 w-6"
                      aria-hidden="true"
                      icon={faTimes}
                    />
                  </button>
                </div>
              </div>
              <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                <Dialog.Panel>
                  <ErrorBoundary>
                    <Formik
                      initialValues={{
                        from: props.current_staff?.id,
                        to: "",
                        files: [],
                        template: 0,
                      }}
                      validateOnChange={false}
                      validateOnBlur={false}
                      onSubmit={async (
                        values,
                        { setSubmitting, setErrors, resetForm }
                      ) => {
                        //Filter out just ticked items
                        let sendListNew = sendList.filter(function (sl) {
                          return sl.checked === true;
                        });

                        if (action === "") {
                          alert("Please choose an Action!");
                        } else {
                          if (sendListNew.length === 0) {
                            alert("Please choose at least 1 person!");
                          } else if (action === 3 && chosenLocation === "") {
                            alert("Please choose a location to move!");
                          } else if (action === "10" && !snoozeUntil) {
                            alert("Please select a snooze date and time!");
                          } else {
                            // Block re-entry if a batch is already being sent.
                            if (isProcessingRef.current) {
                              return;
                            }
                            isProcessingRef.current = true;
                            setSubmitting(true);

                            // Context describing the folder / view the staff
                            // member was on, plus any filters they had applied,
                            // so the backend bulk-action history records it.
                            const viewContext = {
                              folder: props.booking_list_name,
                              location_type: props.type,
                              tag_id: props.tag_id ?? null,
                              collection_tag_id: props.collection_tag_id ?? null,
                              property_id: props.property_id ?? null,
                            };
                            const appliedFilters = {
                              property: selProperty,
                              unit_type: selUnitType,
                              has_bed: selHasBed,
                              closed: selClosed,
                              booking_year: selYear,
                              student_type: selStudentType,
                              documents: selDocuments,
                              budget: selBudget,
                              gender: selGender,
                              bot_flow: selBotFlow,
                              mda_balance: selMDABalance,
                              older_than: selOlderThan,
                              last_msg_from: lastMsgFrom,
                              message_filter: selMessageFilter,
                            };

                            async function processArray(array) {
                              let actionUrl = "";
                              let actionMethod = "post";
                              let bulkData = [];

                              if (action === "1") {
                                actionUrl = "bulk-archive";
                                bulkData = array.map((item) => ({
                                  archive: true,
                                  current_staff_id: current_staff.id,
                                  type: props.type,
                                  id: item.a,
                                  archive_tag_id:
                                    chosenArchiveTag && chosenArchiveTag !== "0"
                                      ? parseInt(chosenArchiveTag, 10)
                                      : null,
                                }));
                              } else if (action === "2") {
                                actionUrl = "bulk-toggle";
                                bulkData = array.map((item) => ({
                                  closed: 1,
                                  current_staff_id: current_staff.id,
                                  type: props.type,
                                  id: item.a,
                                }));
                              } else if (action === "3" || action === "8") {
                                actionUrl = "bulk-assign";
                                bulkData = array.map((item) => ({
                                  location:
                                    chosenLocation === "General"
                                      ? "General"
                                      : chosenLocation,
                                  tag: chosenTag === "" ? 0 : chosenTag,
                                  current_staff_id: current_staff.id,
                                  type:
                                    action === 8 ? "fromrenewal" : props.type,
                                  year_id: selYear,
                                  id: item.a,
                                }));
                              } else if (action === "4" || action === "5") {
                                actionUrl = "bulk-wifi-status-update";
                                bulkData = array.map((item) => ({
                                  user_id: item.f,
                                  property_id: item.i,
                                  location: chosenLocation,
                                  tag: chosenTag === "" ? 0 : chosenTag,
                                  current_staff: current_staff,
                                  type: props.type,
                                }));
                              } else if (action === "6") {
                                actionUrl = "mda/bulk_link_mda";
                                bulkData = array.map((item) => ({
                                  user_id: item.f,
                                  booking_id: item.a,
                                  property_id: item.i,
                                  current_staff: current_staff,
                                  type: props.type,
                                }));
                              } else if (action === "9" || action === "10" || action === "11") {
                                // New bulk actions using the new backend API
                                return null; // Will be handled separately below
                              }

                              try {
                                const response = await axios({
                                  method: actionMethod,
                                  url:
                                    process.env.REACT_APP_API_URL + actionUrl,
                                  data: {
                                    items: bulkData,
                                    view_context: viewContext,
                                    applied_filters: appliedFilters,
                                  },
                                });

                                const { message } = response.data;

                                toast(
                                  <NotificationToast
                                    title="Actioned Successfully"
                                    message={
                                      message ||
                                      "All records have been updated successfully."
                                    }
                                  />
                                );
                              } catch (error) {
                                const errorMessage =
                                  error.response?.data?.message ||
                                  error.message ||
                                  "An error occurred";

                                toast(
                                  <NotificationToast
                                    title="Something went wrong"
                                    message={errorMessage}
                                    type="error"
                                  />
                                );
                              }

                              return true;
                            }

                            if (action === "7") {
                              await axios({
                                method: "post",
                                url:
                                  process.env.REACT_APP_API_URL +
                                  "bulk_set_active",
                                data: sendListNew,
                              })
                                .then((response) => {
                                  toast(
                                    <NotificationToast
                                      title={"Actioned Succesfully"}
                                      message={
                                        "The booking has been updated succesfully."
                                      }
                                    />
                                  );
                                })
                                .catch((error) => {
                                  toast(
                                    <NotificationToast
                                      title="Something went wrong"
                                      message={error}
                                      type="error"
                                    />
                                  );
                                });
                            } else if (action === "9" || action === "10" || action === "11") {
                              // Handle new bulk actions: stop_botflow, snooze, unsnooze
                              try {
                                let actionUrl = "";
                                let bulkData = [];
                                
                                if (action === "9") {
                                  actionUrl = "bulk-stop-botflow";
                                  bulkData = sendListNew.map((item) => ({
                                    id: item.a,
                                    robot_colour: robotColour,
                                    current_staff_id: current_staff.id,
                                  }));
                                } else if (action === "10") {
                                  actionUrl = "bulk-snooze";
                                  bulkData = sendListNew.map((item) => ({
                                    id: item.a,
                                    snooze_until: snoozeUntil,
                                    current_staff_id: current_staff.id,
                                  }));
                                } else if (action === "11") {
                                  actionUrl = "bulk-unsnooze";
                                  bulkData = sendListNew.map((item) => ({
                                    id: item.a,
                                    current_staff_id: current_staff.id,
                                  }));
                                }

                                const response = await axios({
                                  method: "post",
                                  url: process.env.REACT_APP_API_URL + actionUrl,
                                  data: {
                                    items: bulkData,
                                    view_context: viewContext,
                                    applied_filters: appliedFilters,
                                  },
                                });

                                toast(
                                  <NotificationToast
                                    title="Actioned Successfully"
                                    message={response.data.message || "Action completed successfully."}
                                  />
                                );
                              } catch (error) {
                                const errorMessage =
                                  error.response?.data?.message ||
                                  error.message ||
                                  "An error occurred";

                                toast(
                                  <NotificationToast
                                    title="Something went wrong"
                                    message={errorMessage}
                                    type="error"
                                  />
                                );
                              }
                            } else {
                              await processArray(sendListNew);
                            }

                            setSubmitting(false);
                            isProcessingRef.current = false;

                            resetForm();
                            // Close the modal so the same selection can't be
                            // re-submitted, which caused duplicate batches.
                            dispatch(closeModal());
                          }
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        setFieldValue,
                        handleSubmit,
                        isValid,
                        isSubmitting,
                        dirty,
                      }) => (
                        <Form
                          onSubmit={handleSubmit}
                          className="rounded-3xl w-full mt-3"
                        >
                          {/* For some reason this overflow isn't working, I want to make the table scrollable */}
                          <div className="max-h-96 overflow-auto">
                            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 p-3 bg-dark_background">
                              <select
                                name="action_type"
                                onChange={(e) => {
                                  setAction(e.target.value);
                                  // Auto-set filters for specific actions
                                  if (e.target.value === "11") {
                                    // Un-Snooze: only show open bookings
                                    setSelClosed(0);
                                  }
                                  setListLoaded(false); // Trigger list reload to apply filters
                                }}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">Action</option>

                                {actionType &&
                                  actionType.length > 0 &&
                                  actionType.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                              </select>

                              {action && (action === "3" || action === "8") ? (
                                <>
                                  <select
                                    name="action_type"
                                    onChange={(e) => {
                                      const newLocation = e.target.value;
                                      setChosenLocation(newLocation);

                                      // Reset the tag when location changes
                                      setChosenTag("");
                                    }}
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                  >
                                    <option value="">Select a location</option>

                                    {/* Display folders (no tags, not under property) */}
                                    {locations.noTags.length > 0 && (
                                      <optgroup label="Folders">
                                        {locations.noTags.map((location) => (
                                          <option
                                            key={location.id}
                                            value={location.name}
                                          >
                                            {location.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    )}

                                    {/* Display property folders */}
                                    {locations.underProperty.length > 0 && (
                                      <optgroup label="Property Folders">
                                        {locations.underProperty.map((location) => (
                                          <option
                                            key={location.id}
                                            value={location.name}
                                          >
                                            {location.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    )}

                                    {/* Display folders with tags */}
                                    {locations.hasTags.length > 0 && (
                                      <optgroup label="Folders With Tags">
                                        {locations.hasTags.map((location) => (
                                          <option
                                            key={location.id}
                                            value={location.name}
                                          >
                                            {location.name}
                                          </option>
                                        ))}
                                      </optgroup>
                                    )}
                                  </select>
                                </>
                              ) : (
                                ""
                              )}

                              {/* Only show tag selector for locations that have tags */}
                              {chosenLocation &&
                                locations.hasTags.some(
                                  (loc) => loc.name === chosenLocation
                                ) && (
                                  <select
                                    name="tag"
                                    onChange={(e) =>
                                      setChosenTag(e.target.value)
                                    }
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                  >
                                    <option value="">No Tag</option>
                                    {getTagsForLocation(chosenLocation).map(
                                      (tag) => (
                                        <option key={tag.id} value={tag.id}>
                                          {tag.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                )}

                              {/* Archive action: tag dropdown for tags under the Archived folder */}
                              {action === "1" && (
                                <div className="flex flex-col">
                                  <select
                                    name="archive_tag"
                                    value={chosenArchiveTag}
                                    onChange={(e) =>
                                      setChosenArchiveTag(e.target.value)
                                    }
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                  >
                                    <option value="">No Tag</option>
                                    {getTagsForLocation("Archived").map(
                                      (tag) => (
                                        <option key={tag.id} value={tag.id}>
                                          {tag.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  {process.env.REACT_APP_COLOUR === "UC" && (
                                    <p className="text-xs text-gray-500 mt-1">
                                      No Tag = auto-assign by year (from ID).
                                    </p>
                                  )}
                                </div>
                              )}

                              {/* Robot colour selector for Stop Bot Flow action */}
                              {action === "9" && (
                                <select
                                  name="robot_colour"
                                  onChange={(e) => setRobotColour(e.target.value)}
                                  value={robotColour}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  <option value="red">Red Robot</option>
                                  <option value="green">Green Robot</option>
                                </select>
                              )}

                              {/* Snooze datetime picker for Snooze action */}
                              {action === "10" && (
                                <input
                                  type="datetime-local"
                                  name="snooze_until"
                                  onChange={(e) => setSnoozeUntil(e.target.value)}
                                  value={snoozeUntil}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                  placeholder="Snooze until..."
                                />
                              )}

                              <select
                                name="property_id"
                                onChange={(e) => setProp(e)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">All Buildings</option>
                                <option value="1000">No Building</option>

                                {properties &&
                                  properties.length > 0 &&
                                  properties.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                              </select>

                              <select
                                name="chat_type"
                                value={selClosed}
                                onChange={(e) => setClosed(e)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">Open and Closed</option>

                                {closeType &&
                                  closeType.length > 0 &&
                                  closeType.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                              </select>

                              <select
                                name="year_id"
                                onChange={(e) => setYear(e)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="0">All years</option>

                                {years &&
                                  years.length > 0 &&
                                  years.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                              </select>

                              <select
                                name="last_msg_from"
                                onChange={(e) => setLastMsgFrom(e)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="0">
                                  Last Message From Tenant
                                </option>
                                <option value="1">Last Message</option>
                              </select>

                              {/* <select
																name="message_filter_type"
																onChange={(e) => setMessageFilterType(e)}
																className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
															  >
																<option value="0">All</option>
																<option value="1">Last Student Message</option>
																<option value="2">Last Romi Message</option>
															  </select> */}

                              {props.type === "collections" ? (
                                <>
                                  <select
                                    name="chat_type"
                                    onChange={(e) => setWifi(e)}
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                  >
                                    <option value="">WiFi ON and OFF</option>

                                    {wifiType &&
                                      wifiType.length > 0 &&
                                      wifiType.map((p) => (
                                        <option key={p.value} value={p.value}>
                                          {p.label}
                                        </option>
                                      ))}
                                  </select>
                                </>
                              ) : (
                                ""
                              )}

                              <input
                                type="number"
                                placeholder="Older than X days"
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                onChange={(value) => {
                                  setSelOlderThan(value.target.value);
                                  setListLoaded(false);
                                }}
                              />

                              <select
                                name="study_year_id"
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                onChange={(value) => {
                                  setStudyYear(value.target.value);
                                  setListLoaded(false);
                                }}
                              >
                                <option value="0">All Study Years</option>

                                {lookups[8] &&
                                  lookups[8].length > 0 &&
                                  lookups[8].map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                              </select>

                              <select
                                name="unit_type"
                                onChange={(e) => setUnitType(e.target.value)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="0">Ignore Unit Type</option>
                                <option value="1">Has Unit Type</option>
                                <option value="2">No Unit Type</option>
                              </select>

                              {process.env.REACT_APP_COLOUR == "UC" && (
                                <select
                                  name="booking_summary"
                                  onChange={(e) =>
                                    setBookingSummary(e.target.value)
                                  }
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  <option value="0">
                                    Ignore Booking Summary
                                  </option>
                                  <option value="1">Has Booking Summary</option>
                                  <option value="2">No Booking Summary</option>
                                </select>
                              )}

                              {process.env.REACT_APP_COLOUR == "UC" && (
                                <select
                                  name="budget_id"
                                  onChange={(e) => setBudget(e)}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  <option value="">All Budgets</option>

                                  {props.lookups[15] &&
                                    props.lookups[15].length > 0 &&
                                    props.lookups[15].map((p) => (
                                      <option key={p.value} value={p.value}>
                                        {p.label}
                                      </option>
                                    ))}
                                </select>
                              )}

                              <select
                                name="mda_balance"
                                onChange={(e) => setMDABalance(e)}
                                className={selectClass}
                              >
                                {mdaBalanceTypes.map((type) => (
                                  <option key={type.value} value={type.value}>
                                    {type.label}
                                  </option>
                                ))}
                              </select>

                              {selMDABalance === 2 && (
                                <div className="flex items-center space-x-2">
                                  <input
                                    type="number"
                                    placeholder="Min Balance Amount"
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-1 px-2 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary w-1/2"
                                    onChange={(e) => {
                                      setBalanceAmountMin(
                                        parseFloat(e.target.value)
                                      );
                                      setListLoaded(false);
                                    }}
                                    value={balanceAmountMin}
                                  />
                                  <input
                                    type="number"
                                    placeholder="Max Balance Amount"
                                    className="block border font-light border-gray-300 rounded-lg shadow-sm py-1 px-2 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary w-1/2"
                                    onChange={(e) => {
                                      setBalanceAmountMax(
                                        parseFloat(e.target.value)
                                      );
                                      setListLoaded(false);
                                    }}
                                    value={balanceAmountMax}
                                  />
                                </div>
                              )}

                              <select
                                name="gender_type"
                                onChange={(e) => setGender(e)}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">All Genders</option>
                                {genderTypes.map((p) => (
                                  <option key={p.value} value={p.value}>
                                    {p.label}
                                  </option>
                                ))}
                              </select>

                              <select
                                name="documents"
                                onChange={(e) => {
                                  setSelDocuments(e.target.value);
                                  setListLoaded(false);
                                }}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">All Documents</option>
                                <option value="missing">Missing Required Documents</option>
                                <option value="uploaded">All Documents Uploaded</option>
                              </select>

                              <select
                                name="has_bed"
                                onChange={(e) => {
                                  setSelHasBed(e.target.value);
                                  setListLoaded(false);
                                }}
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                              >
                                <option value="">All Bed Status</option>
                                <option value="1">Has Bed</option>
                                <option value="2">No Bed</option>
                              </select>

                              <select
                                name="bot_flow_id"
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                onChange={(e) => {
                                  setSelBotFlow(parseInt(e.target.value));
                                  setListLoaded(false);
                                }}
                              >
                                {botFlowTypes.map((type) => (
                                  <option key={type.value} value={type.value}>
                                    {type.label}
                                  </option>
                                ))}
                              </select>

                              {process.env.REACT_APP_COLOUR !== "QP" && (
                                <select
                                  name="student_type"
                                  onChange={(e) => setFunding(e)}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  <option value="">
                                    {process.env.REACT_APP_COLOUR === "UC" 
                                      ? "All Funding Types" 
                                      : "All Tenant Types"}
                                  </option>

                                  {studentTypes &&
                                    studentTypes.length > 0 &&
                                    studentTypes.map((p) => (
                                      <option key={p.value} value={p.value}>
                                        {p.label}
                                      </option>
                                    ))}
                                </select>
                              )}

                              {process.env.REACT_APP_COLOUR === "UC" && (
                                <select
                                  name="is_renewal"
                                  onChange={(e) => {
                                    setSelIsRenewal(e.target.value);
                                    setListLoaded(false);
                                  }}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  {renewalTypes &&
                                    renewalTypes.length > 0 &&
                                    renewalTypes.map((p) => (
                                      <option key={p.value} value={p.value}>
                                        {p.label}
                                      </option>
                                    ))}
                                </select>
                              )}

                              {process.env.REACT_APP_COLOUR === "QL" && (
                                <select
                                  name="renewal_choice"
                                  onChange={(e) => {
                                    setSelRenewalChoice(e.target.value);
                                    setListLoaded(false);
                                  }}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  {renewalChoiceOptions.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                                </select>
                              )}

                              {process.env.REACT_APP_COLOUR === "QL" && (
                                <select
                                  name="cancellation_type"
                                  onChange={(e) => {
                                    setSelCancellationType(e.target.value);
                                    setListLoaded(false);
                                  }}
                                  className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                >
                                  {cancellationTypeOptions.map((p) => (
                                    <option key={p.value} value={p.value}>
                                      {p.label}
                                    </option>
                                  ))}
                                </select>
                              )}

                              <input
                                type="text"
                                placeholder="Filter by message content"
                                className="block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
                                onChange={(e) =>
                                  setMessageFilter(e.target.value)
                                }
                                value={selMessageFilter}
                              />
                            </div>

                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50">
                                <tr>
                                  <th
                                    colSpan="5"
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-center font-bold text-gray-900 sm:pl-6"
                                  >
                                    Audience -{" "}
                                    {sendList &&
                                      sendList.filter(
                                        (sl) => sl.checked === true
                                      ).length}{" "}
                                    Selected
                                  </th>
                                  <th
                                    colSpan="2"
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-center font-bold text-gray-900 sm:pl-6"
                                  >
                                    Select All
                                    <input
                                      type="checkbox"
                                      className="ml-2"
                                      onChange={(e) =>
                                        changeListAll(e.target.checked)
                                      }
                                    />
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    Building
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    Booking - Year
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    Location
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                  >
                                    Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                  >
                                    Open
                                  </th>
                                  {props.type === "collections" ? (
                                    <>
                                      <th
                                        scope="col"
                                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                      >
                                        WiFi Status
                                      </th>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>

                              <tbody className="divide-y divide-gray-200 bg-white">
                                {sendList &&
                                  sendList.length > 0 &&
                                  props.bookings.length > 0 &&
                                  sendList.map((res) => {
                                    return (
                                      <>
                                        <tr key={res.a}>
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            {res.i ? (
                                              properties.map((p) => {
                                                return (
                                                  <>
                                                    {p.value === res.i
                                                      ? p.label
                                                      : ""}
                                                  </>
                                                );
                                              })
                                            ) : (
                                              <>Not Assigned</>
                                            )}
                                          </td>
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 flex justify-start items-center">
                                            <span
                                              className={classNames(
                                                res.al > 0
                                                  ? "bg-yellow-400"
                                                  : res.s === "a"
                                                    ? "bg-green-400"
                                                    : "bg-red-400",
                                                "block h-2 w-2 rounded-full ring-1 ring-white mr-2"
                                              )}
                                            />
                                            {res.e}
                                            <br />
                                            {
                                              years.find(
                                                (y) => y.value == res.af
                                              )?.label
                                            }
                                            {res.aj == res.a && " (Active)"}
                                          </td>
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            {res.p}
                                          </td>
                                          <td className="px-3 py-4 text-sm text-gray-500">
                                            <div>{res.b} {res.c}</div>
                                            <div className="text-xs text-gray-400">
                                              Sent: {res.n ? (
                                                <TimeSince time={res.n} />
                                              ) : (
                                                "Never"
                                              )}
                                            </div>
                                            <div className="text-xs text-gray-400">
                                              Tenant: {res.nn ? (
                                                <TimeSince time={res.nn} />
                                              ) : (
                                                "Never"
                                              )}
                                            </div>
                                          </td>
                                          <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                            {res.g === 1 ? "Closed" : "Open"}
                                          </td>
                                          {props.type === "collections" ? (
                                            <>
                                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                {res.ac === 1 ? "ON" : "OFF"}
                                              </td>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                          <td className="text-center">
                                            <input
                                              type="checkbox"
                                              onChange={(e) =>
                                                changeList(e, res)
                                              }
                                              checked={res.checked}
                                            />
                                          </td>
                                        </tr>
                                        <tr style={{ borderTop: "0" }}>
                                          <td
                                            colSpan="6"
                                            className="py-2 pl-6 text-sm font-medium text-gray-900"
                                          >
                                            Last Message:{" "}
                                            <span className="text-sm font-normal text-gray-500">
                                              {res.o}
                                            </span>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>

                          <div className="px-6 py-4 ml-auto flex justify-between items-center space-x-5 bg-dark_background rounded-b-3xl">
                            <div className="flex"></div>
                            <div className="pr-4 ">
                              <SubmitButton
                                name="Submit"
                                disabled={!isValid || isSubmitting || !dirty}
                                isSubmitting={isSubmitting}
                                text="Process"
                              />
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </ErrorBoundary>
                </Dialog.Panel>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
